import { createContext } from "react";
var MenuContext = /* @__PURE__ */createContext(null);
export { MenuContext as M };